import axios from 'axios'
import datepicker from 'js-datepicker'
import moment from 'moment'

class Search {
	page = 2
	is_loadmore = false
	list_wrap = document.querySelector('.list-wrap')
	url_loadmore = this.list_wrap?.dataset['url_loadmore']
	datepicker = document.querySelector('.datepicker')
	input_date = this.datepicker?.querySelector('.input-date')
	search_form = document.querySelector('.search-form')
	input_text = this.search_form?.querySelector('.input-text')
	button_submit = this.search_form?.querySelector('.submit')
	data_query_date = this.input_date?.dataset['query_date']
	constructor() {
		this.search()
		this.loadmore()
	}

	search() {
		try {
			let _this = this
			let icon_calendar = this.input_date.closest('div').querySelector('svg')
			let queryDate = ''
			const start = datepicker(this.input_date, {
				id: 1,
				customDays: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
				customMonths: ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'],
				showAllDates: true,
				formatter: (input, date, instance) => {
					input.value = moment(date).format('DD/MM/yyyy')
					queryDate = moment(date).format('yyyy-MM-DD')
				},
			})

			icon_calendar.addEventListener('click', (evt) => {
				evt.stopPropagation()

				// Toggle the calendar.
				const isHidden = start.calendarContainer.classList.contains('qs-hidden')
				start[isHidden ? 'show' : 'hide']()
			})

			this.input_date.addEventListener('input', function (evt) {
				queryDate = this.value !== '' ? this.value : ''
				_this.data_query_date = this.value !== '' ? this.value : ''
			})

			this.button_submit.addEventListener('click', (evt) => {
				evt.preventDefault()
				let queryText = _this.input_text.value
			
				if (queryDate !== '' || _this.data_query_date !== '') {
					window.location.href = `/tim-kiem.html?q=${queryText}&date=${queryDate || _this.data_query_date}`
				} else {
					window.location.href = `/tim-kiem.html?q=${queryText}`
				}
			})
		} catch (error) {
			console.log('Search.datePicker', { message: error.message })
		}
	}

	loadmore() {
		try {
			const _this = this
			let can_loadmore = !!(_this.list_wrap && _this.url_loadmore)
			let view_more_btn = document.querySelector('.view-more')

			view_more_btn?.addEventListener('click', () => {
				if (can_loadmore && _this.is_loadmore === false) {
					_this.is_loadmore = true
					view_more_btn?.closest('div')?.remove()

					axios
						.get(_this.url_loadmore, {
							params: {
								page: _this.page,
								q: _this.input_text.dataset['query_text'],
								date: _this.input_date.dataset['query_date'],
							},
						})
						.then((response) => {
							if (document.querySelector('.loading')) {
								document.querySelector('.loading').remove()
							}
							_this.is_loadmore = false
							_this.list_wrap.insertAdjacentHTML('beforeend', response.data)
							_this.page++
							_this.loadmore()
						})
						.catch((err) => {
							console.log(err)
						})
				}
			})
		} catch (error) {
			console.log('Loadmore.loadmoreByClick', { message: err.message })
		}
	}
}

export default window.addEventListener('DOMContentLoaded', function () {
	new Search()
})
